import { render, staticRenderFns } from "./APChemistry.vue?vue&type=template&id=02b0633e&scoped=true&"
import script from "./APChemistry.vue?vue&type=script&lang=js&"
export * from "./APChemistry.vue?vue&type=script&lang=js&"
import style0 from "./APChemistry.vue?vue&type=style&index=0&id=02b0633e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b0633e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VRow,VToolbar})
